<div mat-dialog-title>
  <h2>Change {{ data.questionCode }} to {{ data.targetTypeText }}?</h2>
</div>
<div mat-dialog-content>
  <div class="empathy-change-question-type-dialog__content">
    <span class="fs__sm fw__400">
      Other questions reference {{ data.questionCode }} in their conditional logic. We'll preserve conditions that are compatible with the new question type and
      remove any that are not.
    </span>

    <div class="empathy-change-question-type-dialog__content__alert">
      <div class="empathy-change-question-type-dialog__content__alert__header">
        <div class="empathy-change-question-type-dialog__content__alert__header-icon">
          <fa-icon [icon]="faExclamationCircle"></fa-icon>
        </div>
        <span class="fs__sm fw__600">Review the conditions that rely on this question</span>
      </div>
      <ul class="empathy-change-question-type-dialog__content__alert__info">
        @for (question of data.affectedQuestions; track question.id) {
          <li class="fs__sm fw__400">{{ question.code }}. {{ question.title | toPlainText }}</li>
        }

        @for (block of data.affectedBlocks; track block.id) {
          <li class="fs__sm fw__400">{{ block.id }}. {{ block.title | toPlainText }}</li>
        }
      </ul>
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <eiq-button [text]="'Cancel'" [style]="'stroked'" [color]="'light'" testId="change-question-type-dialog-cancel" (clicked)="onCancel()"></eiq-button>
  <eiq-button [text]="'Change type'" [color]="'primary'" testId="change-question-type-dialog-confirm" (clicked)="onConfirm()"></eiq-button>
</div>
